export const apiUrl = `https://${EVERON_API_URL}`;
